import type * as React from 'react';
import { post } from '@Domain/Api';
import type { OrganizationPayload } from '@Application/Organizations/Organizations/Actions/organizationsFetched';
import organizationCreated, {
	type OrganizationCreatedAction,
} from '@Application/Organizations/Organizations/Actions/organizationCreated';
import organizationCreationFailed, {
	type OrganizationCreationFailedAction,
} from '@Application/Organizations/Organizations/Actions/organizationCreationFailed';
import type CreateOrganization from '@Application/Organizations/Organizations/Commands/CreateOrganization';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationCreatedAction | OrganizationCreationFailedAction;

export default (command: CreateOrganization) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<OrganizationPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/organizations`,
				command.toJSON(),
			);

			const action = organizationCreated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
